'use client'
import { useRef } from 'react'

import FormRenderer from '@/components/common/Forms/FormRenderer'
import { useMediaQuery } from '@/hooks/useMediaQuery'
import { handleSubmitError } from '@/lib/form-submit-error-handler'
import { cn } from '@/lib/utils'

import type { FormType } from '@/types/contentful/formType'

export const Form = ({ formSchemaUrl, schema }: FormType) => {
  const formRef = useRef<HTMLDivElement>(null)
  const isDesktop = useMediaQuery('(min-width: 768px)') ?? false

  if (!formSchemaUrl && !schema) return null

  return (
    <section ref={formRef} data-name="formio-form" className={cn('w-full bg-grey-100 px-4 py-8 md:px-12 md:py-16 lg:px-28 lg:py-24 xl:px-30')}>
      <div className="flex flex-col gap-6 rounded-xl bg-white p-6 shadow-sm md:flex-row md:gap-[92px] md:p-12 desktop:mx-auto desktop:max-w-content">
        <div className="flex flex-col gap-6 md:w-[40%]">
          <FormRenderer src={formSchemaUrl} schema={schema} onError={() => handleSubmitError({ formRef, isDesktop })} />
        </div>
      </div>
    </section>
  )
}
